import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    paginationContainer: {
        justifyContent: "flex-end",
        alignItems: "center",
        flex: 1
    },
    colActions: {
        justifyContent: "center",
        alignItems: "center",
        width: 50
    },
    colContact: {
        justifyContent: "center",
        flex: 2
    },
    colSector: {
        justifyContent: "center",
        flex: 2
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    activeChipsContainer: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    colCompany: {
        flexDirection: "row",
        alignItems: "center",
        flex: 3
    },
    tableHeaderRow: {
        flexDirection: "row",
        alignItems: "center"
    },
    emptyText: {
        textAlign: "center"
    },
    tableHeaderText: {
        fontWeight: "600"
    },
    listWrapper: {
        flex: 1
    },
    container: {
        flex: 1
    }
});

export default stylesheet;
